import { useState } from "react";
import { Link, useParams } from "react-router-dom";
import { Loader2 } from "lucide-react";
import FamilyLogo from "../../components/FamilyLogo";
import { Button } from "../../components/ui/button";
import { Input } from "../../components/ui/input";
import { Label } from "../../components/ui/label";

const API_URL = process.env.REACT_APP_BACKEND_URL;

function errorDetail(payload, fallback) {
  const detail = payload?.detail;
  if (Array.isArray(detail)) return detail.map((item) => item.msg || item).join(" ");
  return detail || fallback;
}

export default function FamilySetupPassword() {
  const { token } = useParams();
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [doneEmail, setDoneEmail] = useState("");

  const submit = async (event) => {
    event.preventDefault();
    if (password !== confirm) return setError("Le password non coincidono");
    setLoading(true);
    setError("");
    try {
      const res = await fetch(`${API_URL}/api/family/auth/setup`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ token, password }),
      });
      const data = await res.json();
      if (!res.ok) throw new Error(errorDetail(data, "Non è stato possibile attivare l'account"));
      setDoneEmail(data.email || "");
    } catch (err) {
      setError(err.message || "Non è stato possibile attivare l'account");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-[#f7f5fb] px-4 py-10 text-[#3D2868]">
      <div className="w-full max-w-[420px]">
        <div className="mb-8 flex justify-center">
          <FamilyLogo className="mx-auto h-14" />
        </div>
        <section className="rounded-[1.6rem] border border-white/80 bg-white p-6 shadow-[0_24px_70px_rgba(110,72,181,0.08)] sm:p-8">
          {doneEmail ? (
            <div className="space-y-4 text-center">
              <h1 className="text-xl font-extrabold">Password salvata</h1>
              <p className="text-sm leading-6 text-slate-600">
                Ora puoi accedere ad AFFIDYA Family con la tua email
                {" "}
                <strong className="text-[#3D2868]">{doneEmail}</strong>
                {" "}
                (quella su cui hai ricevuto l&apos;invito) e la password che hai appena scelto.
              </p>
              <Link
                to="/family-login"
                className="inline-flex h-11 w-full items-center justify-center rounded-xl bg-[#6e48b5] text-sm font-semibold text-white hover:bg-[#5a3b94]"
              >
                Vai all&apos;accesso
              </Link>
            </div>
          ) : (
            <>
              <div className="mb-6 text-center">
                <h1 className="text-xl font-extrabold">Completa la registrazione</h1>
                <p className="mt-2 text-sm leading-6 text-slate-600">
                  Scegli una password personale di almeno 10 caratteri per attivare il tuo account AFFIDYA Family.
                </p>
              </div>
              <form onSubmit={submit} className="space-y-4">
                <div className="space-y-1.5">
                  <Label htmlFor="new-password">Password</Label>
                  <Input
                    id="new-password"
                    type="password"
                    minLength="10"
                    required
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    className="h-11 rounded-xl"
                    autoComplete="new-password"
                  />
                </div>
                <div className="space-y-1.5">
                  <Label htmlFor="repeat-password">Conferma password</Label>
                  <Input
                    id="repeat-password"
                    type="password"
                    minLength="10"
                    required
                    value={confirm}
                    onChange={(e) => setConfirm(e.target.value)}
                    className="h-11 rounded-xl"
                    autoComplete="new-password"
                  />
                </div>
                {error ? <p className="rounded-xl bg-red-50 px-3 py-2 text-sm text-red-700">{error}</p> : null}
                <Button disabled={loading} className="h-11 w-full rounded-xl bg-[#6e48b5] hover:bg-[#5a3b94]">
                  {loading ? <Loader2 className="mr-2 h-4 w-4 animate-spin" /> : null}
                  Conferma password
                </Button>
              </form>
            </>
          )}
        </section>
      </div>
    </div>
  );
}
